import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { PlatformCaseStudy } from './pages/CaseStudies/Platform';
import { AcquisitionCaseStudy } from './pages/CaseStudies/Acquisition';
import { AppCaseStudy } from './pages/CaseStudies/App';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream text-navy-dark" data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="pt-20" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
            <Route path="/case-study/platform" element={<PlatformCaseStudy data-id="element-12" />} data-id="element-11" />
            <Route path="/case-study/acquisition" element={<AcquisitionCaseStudy data-id="element-14" />} data-id="element-13" />
            <Route path="/case-study/app" element={<AppCaseStudy data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
      </BrowserRouter>
    </div>;
}